import { createContext } from 'react';

export const TableContext = createContext({
  onSort: () => null,
  onRefresh: () => null,
  reorderColumn: () => null,
});
